import React, { lazy, Suspense, useLayoutEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
const LegacyApp = lazy(() => import('./LegacyApp'));
const CuestionarioCerrado = lazy(() => import('./CuestionarioCerrado'));
const ensayoHabilitado = process.env.REACT_APP_CUESTIONARIO_ENSAYO === 'true';
const publicoHabilitado = process.env.REACT_APP_CUESTIONARIO_PUBLICO === 'true';
const Cuestionario = lazy(() => import('./CuestionarioPagina'));
// A fresh document prevents a previously loaded analytics SDK from following this flow.
function AislarEntradaCuestionario() {
  const location = useLocation();
  const anterior = useRef(location.pathname);
  useLayoutEffect(() => {
    if (!/^\/cuestionario(?:\/|$)/.test(anterior.current) && /^\/cuestionario(?:\/|$)/.test(location.pathname)) {
      window.location.reload();
    }
    anterior.current = location.pathname;
  }, [location.pathname]);
  return null;
}
export default function App() {
  return <BrowserRouter><AislarEntradaCuestionario /><Suspense fallback={<p role="status">Cargando…</p>}><Routes>
    <Route path="/cuestionario" element={publicoHabilitado && !ensayoHabilitado ? <Cuestionario /> : ensayoHabilitado && !publicoHabilitado ? <Cuestionario modoEnsayo /> : <CuestionarioCerrado />} />
    <Route path="/*" element={<LegacyApp />} />
  </Routes></Suspense></BrowserRouter>;
}
